module.exports = __webpack_public_path__ + "img/color_amarillo.66fd21ab.svg";